/* slider-click-fix.js — vangnet + sleep-drempel voor CarouselSlider drag-state.
 * A) Root cause: .slider.is-dragging a { pointer-events:none } blijft hangen als een mouseup
 *    verloren gaat (venster/tab-wissel) -> kaart-/collectie-links onklikbaar (rageclicks).
 * B) Het thema zet is-dragging al bij de EERSTE pixel muisbeweging (geen drempel), waardoor
 *    een normale klik met minieme trilling wordt opgegeten (eerste klik na tab-terugkeer).
 *    Onder de drempel halen we is-dragging weer weg; een echte sleep (>6px) blijft werken.
 * Puur additief: main.js wordt niet gewijzigd. */
(function () {
  var THRESHOLD = 6, downX = null, downY = null;

  function clearStuck() {
    var stuck = document.querySelectorAll('.slider.is-dragging, .slider.is-grabbing');
    for (var i = 0; i < stuck.length; i++) {
      var s = stuck[i];
      s.classList.remove('is-dragging', 'is-grabbing');
      var host = s.closest('carousel-slider, product-card-image-slider');
      if (host) { try { host.mousedown = false; } catch (e) {} }
    }
  }
  function endInteraction() { downX = null; downY = null; clearStuck(); }

  /* A — vangnet tegen vastgelopen drag-state */
  window.addEventListener('mouseup', endInteraction, true);
  window.addEventListener('pointerup', clearStuck, true);
  window.addEventListener('pointercancel', clearStuck, true);
  window.addEventListener('blur', endInteraction, true);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') clearStuck();
  });

  /* B — sleep-drempel. Startpunt vastleggen in capture (vóór de thema-handler). */
  window.addEventListener('mousedown', function (e) { downX = e.clientX; downY = e.clientY; }, true);
  /* Bubble op window = ná de thema-handler op .slider: onder de drempel geen sleep. */
  window.addEventListener('mousemove', function (e) {
    if (downX === null) return;
    var dx = e.clientX - downX, dy = e.clientY - downY;
    if (dx * dx + dy * dy < THRESHOLD * THRESHOLD) {
      var els = document.querySelectorAll('.slider.is-dragging');
      for (var i = 0; i < els.length; i++) els[i].classList.remove('is-dragging');
    }
  }, false);
})();
